import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Suspense } from "react";
import useGetRoutes from "./useGetRoutes";
import Error500 from "../pages/ErrorPages/Error500";

const Routes = ({ children }) => {
  const routes = useGetRoutes();

  const router = createBrowserRouter([
    {
      element: children,
      errorElement: <Error500 />,
      children: routes,
    },
  ]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default Routes;
